<template>
  <a-row
    type="flex"
    justify="center"
    align="middle"
    style="min-height: 100vh"
    class="ml-3 mr-3"
  >
    <a-spin v-if="state.loading" size="large" />
    <a-col v-if="!state.loading" :sm="20" :md="14" :lg="10">
      <a-row type="flex" justify="center" align="middle">
        <img
          src="@/assets/images/insured_form/ilustracion.svg"
          style="height: 300px"
        />
      </a-row>
      <a-row type="flex" justify="center" align="middle">
        <a-typography-title :level="2" style="margin-top: 16px">
          Formulario de incorporación de cargas
        </a-typography-title>
      </a-row>
      <a-row type="flex" justify="center" align="middle">
        <a-typography-title :level="4">
          Para completar este formulario debes:
        </a-typography-title>
      </a-row>
      <a-row type="flex" justify="center" align="middle">
        <div style="margin-top: 16px">
          <a-steps direction="vertical">
            <a-step :title="step.title" :description="step.description" />
          </a-steps>
        </div>
      </a-row>
      <a-row type="flex" justify="center" align="middle">
        <router-link
          :to="{
            name: 'DependentsIncorporationNoDeliverableFormStep1',
            params: { token: route.params.token }
          }"
        >
          <a-button style="margin-top: 16px" type="primary" size="large">
            Comenzar
          </a-button>
        </router-link>
      </a-row>
    </a-col>
  </a-row>
</template>

<script setup>
import { onMounted, reactive } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import notification from '@/utils/notifications';
import { FETCH_DEPENDENTS_INCORPORATION_FORM } from '@/store/types';

const route = useRoute();
const router = useRouter();
const store = useStore();

const state = reactive({
  loading: true
});

const step = {
  title: 'Ingresar tus cargas',
  description:
    'Ingresa el rut, nombres, tipo de relación y fecha de nacimiento de tus cargas.'
};
onMounted(async () => {
  try {
    const form = await store.dispatch(
      FETCH_DEPENDENTS_INCORPORATION_FORM,
      route.params.token
    );
    switch (form.stateId) {
      case 3:
        notification(
          'error',
          'Error',
          'La información ya fue procesada por la aseguradora.'
        );
        break;
      case 7:
        notification(
          'error',
          'Error',
          'La información ya fue enviada a la corredora de seguros.'
        );
        break;
      case 8:
        notification(
          'error',
          'Error',
          'La información ya fue enviada a la aseguradora.'
        );
        break;

      default:
        break;
    }
    if (form.stateId !== 1) {
      router.push({ name: 'DependentsIncorporationNoDeliverableFormError' });
    } else if (form.isTokenExpired) {
      router.push({ name: 'DependentsIncorporationNoDeliverableFormExpired' });
    }
    state.loading = false;
  } catch (error) {
    router.push({ name: 'DependentsIncorporationNoDeliverableFormError' });
  }
});
</script>
